import React, { useState, useEffect, useRef } from "react";
import {
  View,
  StyleSheet,
  Dimensions,
  TouchableOpacity,
  Alert,
  Platform,
} from "react-native";
import { Modalize } from "react-native-modalize";
import * as deviceActions from "../store/actions/device";
import { useSelector, useDispatch } from "react-redux";
import DefaultText from "./text/DefaultText";
import Colors from "../constants/Colors";

const CastDeviceModal = (props) => {
  const userDevices = useSelector((state) => state.devices.myDevices);
  const socket = useSelector((state) => state.socket.io);

  const dispatch = useDispatch();
  let TouchableCmp = TouchableOpacity;
  if (Platform.OS === "android" && Platform.Version >= 21) {
    TouchableCmp = TouchableNativeFeedback;
  }
  useEffect(() => {
    dispatch(deviceActions.fetchDevices());
  }, [dispatch]);
  const castToDeviceHandler = (deviceId, name) => {
    Alert.alert("Casting", "Successfully casted to Device " + name);
    dispatch(
      deviceActions.updateDevicePlaylist(deviceId, props.castNFT, socket)
    );
    props.onClose();
    // socket.emit("chat message", "Hi from silo");
    // //socket.emit("nft", userNfts);
  };
  const renderDeviceItem = ({ item }) => {
    return (
      <TouchableCmp
        style={styles.deviceButton}
        onPress={castToDeviceHandler.bind(this, item.deviceId, item.name)}
      >
        <DefaultText style={{ fontSize: 18 }}>{item.name}</DefaultText>
      </TouchableCmp>
    );
  };
  return (
    <Modalize
      ref={props.modalizeRef}
      modalHeight={200}
      modalStyle={styles.modalContainer}
      HeaderComponent={
        <View style={styles.modalHeader}>
          <DefaultText style={styles.castToText}>Cast to</DefaultText>
          <View style={styles.hline}></View>
        </View>
      }
      flatListProps={{
        data: userDevices,
        keyExtractor: (item) => item.deviceId,
        renderItem: renderDeviceItem,
      }}
    />
  );
};

const styles = StyleSheet.create({
  modalContainer: {
    zIndex: 5,

    marginTop: "auto",

    backgroundColor: Colors.background,
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,

    shadowColor: "#000",
    shadowOffset: { width: 0, height: 10 },
    shadowOpacity: 0.1,
    shadowRadius: 12,

    elevation: 4,
    alignItems: "center",
    justifyContent: "center",
  },
  modalHeader: {
    marginVertical: 16,
    alignItems: "center",
    justifyContent: "center",
  },
  castToText: {
    fontSize: 22,
    marginVertical: 16,
  },
  hline: {
    borderBottomColor: Colors.primary,
    borderBottomWidth: 1,
    width: Dimensions.get("window").width * 0.9,
    marginBottom: 6,
  },
  deviceButton: {
    marginVertical: 8,
    width: Dimensions.get("window").width * 0.9,
    alignItems: "center",
    justifyContent: "center",
  },
});
export default CastDeviceModal;
